// Kept free of React Native imports so logic layers (hooks, helpers) can read the
// option list without pulling the component — and its RN dependency graph — with it.
export const DURATION_OPTIONS = [5, 10, 15, 30] as const;
export type DurationOption = (typeof DURATION_OPTIONS)[number];
/** Preset highlighted when the Custom tab opens. Duration is always one of DURATION_OPTIONS and cannot be cleared. */
export const DEFAULT_DURATION_MINUTES: DurationOption = 10;
